export default __webpack_public_path__ + "static/media/Icon-Bills-White.7bfbfca2.svg";